<template>
  <v-radio-group
    hide-details
    xs12
    class="pa-0 ma-1 radio-group-full-width"
    v-model="selected"
    :rules="[v => !!v || 'Item is required']"
    :required="field.data.required"
    @change="changeItem"
    fluid
    nowrap
  >
    <v-container flex class="ma-0 pa-0">
      <v-row>
        <v-radio
          v-if="!field.data.required"
          :label="NO_ITEM.text"
          :value="NO_ITEM"
          class="pa-0 my-2"
        ></v-radio>
      </v-row>
      <v-layout row wrap>
        <v-flex class="my-2" v-for="item in options" :key="item.text" xs12 sm6 md4 lg4 xl3>
          <v-card class="mx-2" height="100%">
            <v-img
              height="78%"
              :src="getImgFromBuffer(images[item.imgId])"
              class="white--text"
              aspect-ratio="1"
              contain
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            >
              <v-card-title class="fill-height align-end" v-text="item.text"></v-card-title>
            </v-img>

            <v-card-actions class="pa-0 ma-0">
              <v-container class="pa-0 ma-0">
                <v-row justify="center" class="pa-0 ma-0">
                  <v-radio
                    :label="`${item.text}${item.hasPrice ? ' ($' + item.price + ')' : ''}`"
                    :value="item"
                  ></v-radio>
                </v-row>
                <v-row justify="center" class="ma-0 pa-0">
                  <v-btn
                    icon
                    @click="subCount(item)"
                    v-if="field.data.countable && selected == item"
                    class="ma-0 pa-0"
                  >
                    <v-icon>mdi-minus-circle-outline</v-icon>
                  </v-btn>
                  <span class="ma-1" icon v-if="field.data.countable && selected == item">{{
                    itemCount
                  }}</span>
                  <v-btn
                    icon
                    class="ma-0 pa-0"
                    @click="addCount(item)"
                    v-if="field.data.countable && selected == item"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-radio-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NO_ITEM from '@/constants/noItem'
export default {
  name: 'ProductsCardsRadio',
  data() {
    return {
      valid: false,
      selected: [],
      options: [],
      itemCount: 1,
      NO_ITEM
    }
  },
  created() {
    if (this.options.length == 0) {
      this.options = [...this.field.data.attrs.options]
      if (this.field.data.countable) {
        this.options.forEach(item => {
          if (!item.count) item.count = 1
        })
      }
      this.loadOriginalImages(this.field)
    }
    if (this.defaultValue) {
      this.selected = this.defaultValue
      this.itemCount = this.selected.count
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => ''
    },
    defaultValue: {
      type: Object,
      default: null
    }
  },
  computed: {
    images() {
      return this.allImages()
    }
  },
  methods: {
    ...mapActions('images', ['loadOriginalImages']),
    ...mapGetters('images', ['allImages']),
    addCount(item) {
      item.count++
      this.itemCount = item.count
      this.changed()
    },
    subCount(item) {
      if (item.count > 1) item.count--
      this.itemCount = item.count
      this.changed()
    },
    getImgFromBuffer(buffer) {
      try {
        return 'data:image/jpg;base64, ' + buffer.toString('base64')
      } catch {
        return 'img/no_image.png'
      }
    },
    getCardTitle(item) {
      return `${item.text} ${item.hasPrice ? ` ($ ${item.price})` : ''}`
    },
    getFieldRules() {
      const rulesF = []
      if (this.field.data.required) {
        rulesF.push(value => (value && value.length > 0) || 'Required.')
      }
      return rulesF
    },
    getValueObj(item) {
      const obj = { text: item.text }
      if (item.hasPrice) obj.price = item.price
      if (this.field.data.countable) obj.count = item.count
      return obj
    },
    changeItem() {
      if (this.selected != NO_ITEM) {
        this.selected.count = 1
        this.itemCount = 1
      }
      this.changed()
    },
    changed() {
      this.onChange({
        id: this.field._id,
        value: this.getValueObj(this.selected),
        rawValues: this.selected,
        ...this.getValidationResults()
      })
    },
    getValidationResults() {
      return this.selected.text
        ? { errMsg: null, valid: true }
        : { errMsg: 'Required', valid: false }
    }
  }
}
</script>

<style scoped>
.radio-group-full-width >>> .v-input__control {
  width: 100%;
}
.v-card__actions {
  height: 22%;
}
</style>
